<template>
  <div class="shows">
    <!-- <div class="showsCommorCont crumbs"><a href="/">Home</a>> Listen Live</div> -->
    <!-- 日期选择导航 -->
    <div class="showsDateNav">
      <div class="showsDateNavCon showsCommorCont">
        <div class="swiper-container showsNavSlide">
          <div class="swiper-wrapper">
            <div v-for='(item,key) in curDateList' :key="key" class="swiper-slide" :class="{'current':item.date == curDateStr}" @click="getClickTime(item.date,key)">
              <span>
                {{item.week}}<br>{{item.date}}
              </span>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    
    <!-- 跳转至 凌晨-早晨-午间-下午 -晚间 -->
    <div class="showsCommorCont date-list-nav">
      跳转至：<a data-flag="#dawn" @click="toDate($event)">凌晨</a> │
      <a data-flag="#morning" @click="toDate($event)">早晨</a> │ <a data-flag="#noon" @click="toDate($event)">午间</a> │
      <a data-flag="#afternoon" @click="toDate($event)">下午</a> │ <a data-flag="#night" @click="toDate($event)">晚间</a>
    </div>
    <!-- 跳转节点 凌晨 -->
    <div class="showsCommorCont time-node">
      <div class="time-node-title" id="dawn">凌晨</div>
      <ul class="time-node-content">
        <li v-for="(item,index) in allList" :key="index" v-if="item.startTime<'06:00'">
          <i class="d"></i
          ><router-link :to="'/columnList/'+'1/'+item.programId" class="item" 
            ><span class="item-time">{{item.time}}</span
            ><img
              :src="item.programUrl"
              class="item-img"
              alt=""
            />
            <div class="item-txt">
              <h3>{{item.title}}</h3>
              <span>主持人</span>
              <p
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                "
              >
            {{item.info}}
              </p>
              <span class="item-time-wap">{{item.time}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 跳转是早晨 -->
    <div class="showsCommorCont time-node">
      <div class="time-node-title" id="morning">早晨</div>
      <!-- v-if="item.startTime<'09:00'&&item.startTime>='06:00'" -->
       <ul class="time-node-content">
        <li v-for="(item,index) in allList" :key="index" v-if="item.startTime<'09:00'&&item.startTime>='06:00'">
          <i class="d"></i
          ><router-link :to="'/columnList/'+'1/'+item.programId" class="item" 
            ><span class="item-time">{{item.time}}</span
            ><img
              :src="item.programUrl"
              class="item-img"
              alt=""
            />
            <div class="item-txt">
              <h3>{{item.title}}</h3>
              <span>主持人</span>
              <p
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                "
              >
            {{item.info}}
              </p>
              <span class="item-time-wap">{{item.time}}</span>
            </div>
          </router-link>
        </li>
      </ul>



    </div>
    <!-- 跳转至午间 -->
    <div class="showsCommorCont time-node">
      <div class="time-node-title" id="noon">午间</div>
      <!-- v-if="item.startTime<'13:00'&&item.startTime>='09:00'" -->
      <ul class="time-node-content">
        <li v-for="(item,index) in allList" :key="index" v-if="item.startTime<'13:00'&&item.startTime>='09:00'">
          <i class="d"></i
          ><router-link :to="'/columnList/'+'1/'+item.programId" class="item" 
            ><span class="item-time">{{item.time}}</span
            ><img
              :src="item.programUrl"
              class="item-img"
              alt=""
            />
            <div class="item-txt">
              <h3>{{item.title}}</h3>
              <span>主持人</span>
              <p
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                "
              >
            {{item.info}}
              </p>
              <span class="item-time-wap">{{item.time}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 跳转至下午 -->
    <div class="showsCommorCont time-node">
      <div class="time-node-title" id="afternoon">下午</div>
      <!-- v-if="item.startTime<'19:00'&&item.startTime>='13:00'" -->
      <ul class="time-node-content">
        <li v-for="(item,index) in allList" :key="index" v-if="item.startTime<'19:00'&&item.startTime>='13:00'">
          <i class="d"></i
          ><router-link :to="'/columnList/'+'1/'+item.programId" class="item" 
            ><span class="item-time">{{item.time}}</span
            ><img
              :src="item.programUrl"
              class="item-img"
              alt=""
            />
            <div class="item-txt">
              <h3>{{item.title}}</h3>
              <span>主持人</span>
              <p
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                "
              >
            {{item.info}}
              </p>
              <span class="item-time-wap">{{item.time}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 跳转至晚间 -->
    <div class="showsCommorCont time-node">
      <div class="time-node-title" id="night">晚间</div>
      <!-- v-if="item.startTime>='19:00'" -->
       <ul class="time-node-content">
        <li v-for="(item,index) in allList" :key="index" v-if="item.startTime>='19:00'">
          <i class="d"></i
          ><router-link :to="'/columnList/'+'1/'+item.programId" class="item" 
            ><span class="item-time">{{item.time}}</span
            ><img
              :src="item.programUrl"
              class="item-img"
              alt=""
            />
            <div class="item-txt">
              <h3>{{item.title}}</h3>
              <span>主持人</span>
              <p
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                "
              >
            {{item.info}}
              </p>
              <span class="item-time-wap">{{item.time}}</span>
            </div>
          </router-link>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "Shows",
  data() {
    return {
     msg: "shows",
     curDateList:[],
     curDateStr:'',
     screenWidth:document.documentElement.clientWidth,
     showsNavSwiper:null,
     allList:[]
    };
  },
  methods: {
    // 去详情页
    // toDetail(programId){
    //   this.$router.push({path:"/columnList/"+programId})
    //   //  this.$router.push({path:"/columnList",query: { id: programId }})
      
    // },
    // getClickTime 点击的时候 切换list
    getClickTime(time,index){
      var _this = this;
      if(this.screenWidth > 900){
        switch(index - 25) {
          case -25:
            _this.showsNavSwiper.slideTo(index+5);
          break;
          case -24:
            _this.showsNavSwiper.slideTo(index+4);
          break;
          case -23:
            _this.showsNavSwiper.slideTo(index+3);
          break;
          case -22:
            _this.showsNavSwiper.slideTo(index+2);
          break;
          case -21:
            _this.showsNavSwiper.slideTo(index+1);
          break;
          case 0:
            _this.showsNavSwiper.slideTo(index-1);
          break;
          case 1:
            _this.showsNavSwiper.slideTo(index-2);
          break;
          case 2:
            _this.showsNavSwiper.slideTo(index-3);
          break;
          case 3:
            _this.showsNavSwiper.slideTo(index-4);
          break;
          case 4:
            _this.showsNavSwiper.slideTo(index-5);
          break;
          default:
            _this.showsNavSwiper.slideTo(index);
        }
      }
      
      this.curDateStr=time;
      this.getTodayList();
      // this.curDateList[index].addclass("current");
    },


    //  test
    getTodayList:function(){
      //  页面显示的当日 this.curDateStr
      var  _this= this;
      _this.$http.post('/qertyuiy/program/programList?startTime='+_this.curDateStr+'&endTime='+_this.curDateStr)
      .then(function(res){
        
        _this.allList=res.data.data[0]; 
         
         
           
      })
      .catch(function(e){

      })
    },
    getWeek:function(dateString) {
        var dateArray = dateString.split("-");
        var date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
        return "星期" + "日一二三四五六".charAt(date.getDay());
    },
    getAll:function(begin, end) { //返回 日期的数组 如 ['2020-07-10','2020-07-11']
    var _this = this;
        var arr = [];
        var ab = begin.split("-");
        var ae = end.split("-");
        var db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
        var de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
        var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
        var unixDe = de.getTime() - 24 * 60 * 60 * 1000;
        for (var k = unixDb; k <= unixDe;) {
            k = k + 24 * 60 * 60 * 1000;
            var ops = {
              week:this.getWeek((new Date(parseInt(k))).format()),
              date:(new Date(parseInt(k))).format()
            }
            arr.push(ops);
        }
        _this.curDateList = arr;
    },
    getNextDate:function(date,day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
    },
    dateNavInit:function(){
      var _this = this , dateList = _this.curDateList , dateStr = _this.curDateStr , _index;
      for(var i=0;i<dateList.length;i++){
        if(dateList[i].date == dateStr){
          _index = i;
        }
      }
      if(this.screenWidth <= 900){
        _this.$nextTick(function(){
          _this.showsNavSwiper = new Swiper('.showsNavSlide', {
            loop: false, // 循环模式选项
            slidesPerView : 3,
            slidesPerGroup : 1,
            prevButton: '.swiper-button-prev',//不要忘记点
            nextButton: '.swiper-button-next',
            slideToClickedSlide: true,
            centeredSlides : true,
          });
          switch(_index - 25) {
            case -25:
              _this.showsNavSwiper.slideTo(_index+5);
            break;
            case -24:
              _this.showsNavSwiper.slideTo(_index+4);
            break;
            case -23:
              _this.showsNavSwiper.slideTo(_index+3);
            break;
            case -22:
              _this.showsNavSwiper.slideTo(_index+2);
            break;
            case -21:
              _this.showsNavSwiper.slideTo(_index+1);
            break;
            case 0:
              _this.showsNavSwiper.slideTo(_index-1);
            break;
            case 1:
              _this.showsNavSwiper.slideTo(_index-2);
            break;
            case 2:
              _this.showsNavSwiper.slideTo(_index-3);
            break;
            case 3:
              _this.showsNavSwiper.slideTo(_index-4);
            break;
            case 4:
              _this.showsNavSwiper.slideTo(_index-5);
            break;
            default:
              _this.showsNavSwiper.slideTo(_index);
          }
        })
      }else{
        _this.$nextTick(function(){
          _this.showsNavSwiper = new Swiper('.showsNavSlide', {
            loop: false, // 循环模式选项
            slidesPerView : 11,
            slidesPerGroup : 1,
            prevButton: '.swiper-button-prev',//不要忘记点
            nextButton: '.swiper-button-next',
            slideToClickedSlide: true,
            centeredSlides : true,
          });
          switch(_index - 25) {
            case -25:
              _this.showsNavSwiper.slideTo(_index+5);
            break;
            case -24:
              _this.showsNavSwiper.slideTo(_index+4);
            break;
            case -23:
              _this.showsNavSwiper.slideTo(_index+3);
            break;
            case -22:
              _this.showsNavSwiper.slideTo(_index+2);
            break;
            case -21:
              _this.showsNavSwiper.slideTo(_index+1);
            break;
            case 0:
              _this.showsNavSwiper.slideTo(_index-1);
            break;
            case 1:
              _this.showsNavSwiper.slideTo(_index-2);
            break;
            case 2:
              _this.showsNavSwiper.slideTo(_index-3);
            break;
            case 3:
              _this.showsNavSwiper.slideTo(_index-4);
            break;
            case 4:
              _this.showsNavSwiper.slideTo(_index-5);
            break;
            default:
              _this.showsNavSwiper.slideTo(_index);
          }
        })
      }
      
    },
    toDate:function(event){
      var _this = this , _el = $(event.target) , _targetEl , _targetHeight = 0;
      _targetEl = $(_el.attr('data-flag'));
      _targetHeight = _targetEl.offset().top;
      _this.$nextTick(function(){
        $("html,body").animate({scrollTop:_targetHeight-200}, 100);
      })
      
    }
  },
  mounted() {
    Date.prototype.format = function() {  
        var s = '';  
        var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));  
        var day = this.getDate()>=10?this.getDate():('0'+this.getDate());  
        s += this.getFullYear() + '-'; // 获取年份。  
        s += mouth + "-"; // 获取月份。  
        s += day; // 获取日。 
        
      
        return (s); // 返回日期。  
    }; 
    this.curDateStr = new Date().format();
    this.getAll(this.getNextDate(new Date().format(),-23),this.getNextDate(new Date().format(),6));
    this.dateNavInit();
    // 获取今日的 全部list
    this.getTodayList();
  },
};
</script>


<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.shows {
  background-color: #f3f4f5;
}
ul {
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
ol,
ul {
  padding: 0;
  list-style: none;
  list-style-image: none;
}
li {
  display: list-item;
  text-align: -webkit-match-parent;
}
a {
  text-decoration: none;
  background: transparent;
}
.showsCommorCont {
  width: 1280px;
  margin: 0 auto;
}
// 导航栏
.crumbs {
  font-size: 14px;
  color: #999;
  height: 64px;
  line-height: 54px;
  a {
    font-size: 14px;
    color: #999;
  }
}
// date-list
.date-list {
  margin-bottom: 0;
  position: relative;
  height: 75px;
  background-color: #fff;
  overflow: hidden;
  //date-list-content
  .date-list-content {
    position: relative;
    height: 75px;
    margin: 0 30px;
  }
  // bx-wrapper
  .bx-wrapper {
    max-width: 1276px;
    //
    .bx-viewport {
      width: 100%;
      overflow: hidden;
      position: relative;
      height: 76px;
      ul {
        width: 30215%;
        margin: 0;
        position: relative;
        left: 0;
        top: 0;
        transition-duration: 0s;
        transform: translate3d(-3364px, 0px, 0px);
        li {
          padding: 0;
          border-right: solid 1px #dcdee3;
          float: left;
          list-style: none;
          position: relative;
          width: 115px;

          a {
            display: block;
            padding: 10px 0;
            height: 56px;
            text-align: center;
            font-size: 14px;
            line-height: 2em;
            color: #999;
          }
          a.active {
            background-color: #31a9de;
            color: #fff;
          }
          a:hover {
            background-color: #31a9de;
            color: #fff;
          }
        }
      }
    }
    //控制器左右
    .bx-controls-direction {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      //
      .bx-prev,
      .bx-next {
        position: absolute;
        width: 30px;
        height: 75px;
        top: 0;
        overflow: hidden;
        text-indent: -200px;
        font-size: 12px;
        background: url("../../static/img/sprite-icon.png") no-repeat;
        background-size: 300px 300px;
      }
      .bx-prev {
        left: -30px;
        background-position: 0 -40px;
      }
      .bx-next {
        right: -30px;
        background-position: -35px -40px;
      }
    }
  }
}
.showsDateNav{margin-top: 35px;}
//  跳转至 凌晨-早晨-午间-下午 -晚间-------------------------------------------------
.date-list-nav {
  height: 20px;
  line-height: 20px;
  margin-top: 35px;
  a{cursor: pointer;}
}
.time-node-title {
  padding: 30px 0;
}
//------------------
.time-node-content {
  border-left: solid 1px #ccc;
  margin-left: 24px;
  padding-left: 39px;
  border-left: solid 1px #ccc;
  margin-left: 24px;
  padding-left: 39px;
  li {
    position: relative;

    //---
    i.d {
      position: absolute;
      left: -46px;
      top: 0px;
      display: block;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background-color: #ccc;
    }
    //img
    a.item {
      display: block;
      height: 160px;
      padding: 36px 0 31px 15px;
      overflow: hidden;
      //--
      .item-time {
        display: block;
        width: 65px;
        color: #999;
        float: left;
      }
      .item-img {
        width: 238px;
        height: 160px;
        display: block;
        float: left;
      }
      .item-txt {
        margin-left: 333px;
        font-size: 18px;
        padding-top: 15px;
        line-height: 24px;
        h3 {
          font-weight: normal;

          overflow: hidden;
          font-size: 24px;
          line-height: 30px;
          max-height: 30px;
        }
        span {
          margin-top: 9px;
          display: block;
          color: #999;
        }
        p {
          margin-top: 34px;
          height: 48px;
          color: #666;
        }
        .item-time-wap {
          display: none;
        }
      }
    }
  }
  li:hover {
    background: #fff;
  }
}

.showsDateNav{
  .showsDateNavCon{
    height: 75px;
    position: relative;
    /deep/ .swiper-container{
      width: 1220px;
      height: 100%;
      margin: auto;
      background-color: #fff;
      position: unset;
      .swiper-slide{
        width: 115px;
        position: relative;
        padding: 0;
        border-right: solid 1px #dcdee3;
        box-sizing: border-box;
        cursor: pointer;
        span{
          display: block;
          padding: 10px 0;
          height: 56px;
          text-align: center;
          font-size: 14px;
          line-height: 2em;
          color: #999;
        }
        span:hover{background-color: #31a9de;color: #fff;}
      }
      .swiper-slide.current{
        span{background-color: #31a9de;color: #fff;}
      } 
      .swiper-button-prev, .swiper-button-next{
        height: 75px;
        width: 30px;
        background-color: transparent;
        background: url('../../static/img/sprite-icon.png') no-repeat;
        background-size: 300px 300px;
      }
      .swiper-button-prev:hover, .swiper-button-next:hover{
        background-color: rgba(0,0,0,.7);
      }
      .swiper-button-prev:after, .swiper-button-next:after{font-size: 30px;}
      .swiper-button-next{top: 0;right: 0;background-position: -35px -40px;margin: 0;}
      .swiper-button-prev{top: 0;left: 0;background-position: 0 -40px;margin: 0;}
    }
  }
}
</style>

<style lang="scss" scoped>
// 适配移动端页面
@media screen and (max-width: 900px) {
  .shows {
    background: #fff;
  }
  .showsCommorCont {
    width: 100%;
  }
  //隐藏 元素
  .crumbs {
    display: none;
  }
  //@at-root
  .date-list-nav {
    display: none;
  }
  .time-node-title {
    display: none;
  }
  .time-node-content li i.d {
    display: none;
  }
  // ---
  .time-node {
    .time-node-content {
      margin: 0;
      padding: 0;
      border-left: 0px;
      li {
        position: relative;
        display: list-item;
        text-align: -webkit-match-parent;
        a.item {
          display: block;

          height: 80px;

          padding: 10px;
          overflow: hidden;
          //sh
          .item-time {
            display: none;
          }
          //@at-root
          .item-img {
            width: 119px;
            height: 80px;
            display: block;
          }
          //--
          .item-txt {
            margin-left: 129px;
            font-size: 14px;
            line-height: 20px;
            padding: 0;

            h3 {
              font-size: 16px;
              line-height: 20px;
              font-weight: normal;
              max-height: 20px;
              overflow: hidden;
              margin: 0;
            }
            //--
            span {
              display: block;
              color: #999;
              margin: 0;
            }
            //---
            p {
              color: #666;
              height: 20px;
              margin: 0;
            }
            .item-time-wap {
              margin: 0;
              display: block;
            }
          }
        }
      }
    }
  }
  .time-node{margin-top: .35rem;}
  .showsDateNav{
    margin-top: .35rem;
    .showsDateNavCon{
      /deep/ .swiper-container{
        width: 90%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Shows.vue